// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
import moment from "moment";
import FormatType from "../models/date";

export const getDurationTime = (
  startTime: moment.Moment,
  endTime: moment.Moment
) => {
  const timeNow = moment(endTime);
  const timeStart = moment(startTime);
  const duration = moment(moment(timeNow).diff(moment(timeStart)));
  const hours = moment(timeNow).diff(moment(timeStart), "hour");
  const minutes = duration.format("mm");
  const seconds = duration.format("ss");
  return `${hours}:${minutes}:${seconds}`;
};

export const getDuration = (
  startAt: string | null | undefined,
  endAt: string | null | undefined
): string => {
  if (!startAt) {
    return " 〜 ";
  }
  const startString = `${moment(startAt).format(
    FormatType["YYYY/MM/DD HH:mm"]
  )} 〜 `;
  if (!endAt) {
    return startString;
  }
  const endString =
    moment(startAt).format(FormatType["YYYY/MM/DD"]) ===
    moment(endAt).format(FormatType["YYYY/MM/DD"])
      ? moment(endAt).format(FormatType["HH:mm"])
      : moment(endAt).format(FormatType["YYYY/MM/DD HH:mm"]);
  return startString + endString;
};
